import { useState, useEffect } from 'react';
import styles from '../../../../components/tabela/Tabela.module.css';
import useFetch from '../../../../components/hooks/useFetch.js';
import iconeExcluir from '../../../../assets/img/delete.svg';
import iconeIncluir from '../../../../assets/img/add-user.svg';
import iconeVisualizar from '../../../../assets/img/acompanhar.svg';
import iconeEditar from '../../../../assets/img/edit.svg';
import Input from '../../../../components/form/Input.js';
import { PERMISSIONARIO_EXCLUIR_LISTA } from '../../../../services/delegacaoAcesso.js';
import useModalConfirmacao from '../../../../components/hooks/useModalConfirmacao.js';
import { abreAlertaDialog } from '../../../../components/modal/AlertaDialog.js';
import { useNavigate } from 'react-router-dom';
import Paginador from '../../../../components/paginador/Paginador';

const TabelaDelegacao = ({
  dadosPagina,
  acaoMudaPagina,
  dadosDelegacao,
  dados,
  dadosPerfil,
  mostraColunaAcoes = true,
  habilitaInclusao,
  acaoInclusao,
  habilitaExclusao,
  acaoExclusao,
  habilitaEdicao,
  acaoEdicao,
  habilitaInformacao,
  acaoInformacao,
  headers,
  ipAddress,
  idCorreiosPJ,
  mensagemTabelaVazia = 'Dados não encontrados :(',
}) => {
  if (!dadosDelegacao || dadosDelegacao?.length === 0) {
    return (
      <div className={styles.noData}>
        <div>{mensagemTabelaVazia}</div>
      </div>
    );
  }
  const { request } = useFetch();
  const [itensMarcadosTabela, setItensMarcadosTabela] = useState([]);
  const navigate = useNavigate();
  const temAcoes =
    mostraColunaAcoes &&
    (!!acaoInclusao || !!acaoExclusao || !!acaoEdicao || !!acaoInformacao);
  const dadosOrganizados = organizaDados(dadosDelegacao, headers);
  const [marcados, setMarcados] = useState([]);
  const { abreModalConfirmacao } = useModalConfirmacao();

  useEffect(() => {
    const idMarcar = itensMarcadosTabela.map((item) => item.idCorreiosPF);
    const estadoInicialCheck = dadosOrganizados.map((item) =>
      idMarcar.includes(item.idCorreiosPF),
    );
    setMarcados(estadoInicialCheck);
  }, [itensMarcadosTabela]);
  const handleCheckBoxChange = (id) => {
    setItensMarcadosTabela((prevItensMarcados) => {
      if (prevItensMarcados.includes(id)) {
        return prevItensMarcados.filter((item) => item !== id);
      } else {
        return [...prevItensMarcados, id];
      }
    });
  };
  const handleSelecionaTodos = () => {
    setIsCheckedSelecionaTodos(!isCheckedSelecionaTodos);
  };
  const [selecionados, setSelecionados] = useState(0);
  const [isCheckedSelecionaTodos, setIsCheckedSelecionaTodos] = useState(false);
  useEffect(() => {
    const arrayInicial = new Array(dadosOrganizados.length).fill(false);
    if (isCheckedSelecionaTodos) {
      const todosSelecionados = arrayInicial.map(() => true);
      setMarcados(todosSelecionados);
      setItensMarcadosTabela(dadosOrganizados);
    } else {
      const nenhumSelecionado = arrayInicial.map(() => false);
      setMarcados(nenhumSelecionado);
      setItensMarcadosTabela([]);
    }
  }, [isCheckedSelecionaTodos]);

  const excluirPermissionarios = () => {
    if (isCheckedSelecionaTodos) {
      abreModalConfirmacao(
        `Todos permissionários serão removidos. Confirma ?`,
        () => excluiPermissionariosSelecionados(),
      );
    } else {
      const usuariosMarcados = marcados.filter((item) => item === true).length;
      if (usuariosMarcados === 0) {
        abreAlertaDialog('Não foi selecionado nenhum permissionário');
        return;
      }
      var msg;
      if (usuariosMarcados > 1) {
        msg = 'Os permissionários selecionados serão removidos. Confirma ?';
      } else {
        msg = 'O permissionário selecionado será removido. Confirma ?';
      }
      abreModalConfirmacao(msg, () => excluiPermissionariosSelecionados());
      setItensMarcadosTabela([]);
      navigate('/delegacaoAcesso', {
        state: { dados, dadosPerfil },
      });
    }
  };
  const excluiPermissionariosSelecionados = async () => {
    var idCorreiosExcluir = [];
    let j = 0;
    marcados.forEach((item, i) => {
      if (item === true) {
        idCorreiosExcluir[j] = dadosOrganizados[i].idCorreiosPF;
        j++;
      }
    });
    const { response } = await request(
      PERMISSIONARIO_EXCLUIR_LISTA(idCorreiosPJ, idCorreiosExcluir, ipAddress),
    );
    if (response.ok) {
      abreAlertaDialog('Permissionário(s) excluído(s) com sucesso.');
    }
  };

  return (
    <>
      <div className="lista-permissoes">
        <div className="selecao">
          <Input
            id="selecionarTodos"
            name="selecionarTodos"
            className="input-checkbox"
            type="checkbox"
            onClick={handleSelecionaTodos}
            checked={isCheckedSelecionaTodos}
          />

          <button
            title="excluir selecionados"
            className="btn-txt so-icone"
            onClick={() => excluirPermissionarios()}
          >
            <i className="ic-lixo"></i>
          </button>
          <div className="legenda">
            {itensMarcadosTabela.length} usuário(s) selecionado(s)
          </div>
          <Paginador
            dadosPagina={dadosPagina}
            acaoMudaPagina={acaoMudaPagina}
          />
        </div>
      </div>

      <div>
        <table className="th-fixo cards mob">
          <thead>
            <tr>
              <th> Marcar</th>
              {headers.map((header) => (
                <th key={header.key}>{header.value}</th>
              ))}
              {temAcoes && <th> Ações</th>}
            </tr>
          </thead>
          <tbody>
            {dadosOrganizados.map((linha, i) => (
              <tr key={i}>
                <td>
                  <Input
                    title="Marcar"
                    type="checkbox"
                    name="marcar"
                    className="marcar"
                    checked={marcados[i] || false}
                    onChange={() => handleCheckBoxChange(linha.original)}
                  ></Input>
                </td>
                {Object.keys(linha)
                  .filter((coluna) => coluna !== 'original')
                  .map((coluna, j) => (
                    <td key={j} data-th={headers[j].value}>
                      {linha[coluna]?.render
                        ? linha[coluna].render(
                            linha.original[coluna],
                            linha.original,
                          )
                        : linha[coluna] || ''}
                    </td>
                  ))}
                {temAcoes && (
                  <td>
                    <div className="acoes">
                      {acaoInformacao && (
                        <div
                          style={{
                            visibility: habilitaInformacao(linha.original)
                              ? 'visible'
                              : 'hidden',
                          }}
                        >
                          <button
                            title="Visualizar Acessos"
                            className="info btn-txt so-icone"
                            {...(acaoInformacao
                              ? {
                                  onClick: () => acaoInformacao(linha.original),
                                }
                              : {})}
                          >
                            {' '}
                            <i className="ic-acompanhar"></i>
                          </button>
                        </div>
                      )}

                      {acaoInclusao && (
                        <div
                          style={{
                            visibility: habilitaInclusao(linha.original)
                              ? 'visible'
                              : 'hidden',
                          }}
                        >
                          <button
                            title="Incluir"
                            className="incluir btn-txt so-icone"
                            {...(acaoInclusao
                              ? {
                                  onClick: (event) => {
                                    event.preventDefault();
                                    acaoInclusao(linha.original);
                                  },
                                }
                              : {})}
                          >
                            <i className="ic-adicionar-circulo"></i>
                          </button>
                        </div>
                      )}
                      {acaoEdicao && (
                        <div
                          style={{
                            visibility: habilitaEdicao(linha.original)
                              ? 'visible'
                              : 'hidden',
                          }}
                        >
                          <button
                            title="Editar"
                            className="editar btn-txt so-icone"
                            {...(acaoEdicao
                              ? { onClick: () => acaoEdicao(linha.original) }
                              : {})}
                          >
                            <i className="ic-editar"></i>
                          </button>
                        </div>
                      )}

                      {acaoExclusao && (
                        <div
                          style={{
                            visibility: habilitaExclusao(linha.original)
                              ? 'visible'
                              : 'hidden',
                          }}
                        >
                          <button
                            title="Excluir"
                            className="delete btn-txt so-icone"
                            {...(acaoExclusao
                              ? {
                                  onClick: (event) => {
                                    event.preventDefault();
                                    acaoExclusao(linha.original);
                                  },
                                }
                              : {})}
                          >
                            <i className="ic-lixo"></i>
                          </button>
                        </div>
                      )}
                    </div>
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};

function organizaDados(lista, headers) {
  const listaOrganizada = [];
  lista.forEach((linha) => {
    let linhaOrganizada = {};
    headers.forEach((header) => {
      const obj = {};
      obj[header.key] = header.render
        ? { render: header.render }
        : linha[header.key];
      linhaOrganizada = { ...linhaOrganizada, ...obj };
    });

    linhaOrganizada.original = linha;
    listaOrganizada.push(linhaOrganizada);
  });

  return listaOrganizada;
}

export default TabelaDelegacao;
